function waitForElmShadow(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)?.shadowRoot) {
      return resolve(document.querySelector(selector).shadowRoot);
    }

    const observer = new ResizeObserver(() => {
      if (document.querySelector(selector)?.shadowRoot) {
        resolve(document.querySelector(selector).shadowRoot);
        observer.disconnect();
      }
    });

    observer.observe(document.body);
  });
}
(function () {
  var $kueskiWidget = $();
  var timer = setInterval(() => {
    $kueskiWidget = $('kueskipay-widget');
    if ($kueskiWidget.length > 0) {
      clearInterval(timer);
      if (typeof KueskipayAdvertising !== 'undefined') {
        // eslint-disable-next-line no-undef
        new KueskipayAdvertising().init();
      }
      waitForElmShadow('kueskipay-widget').then(() => {
        var shadow;
        var styles = document.createElement('style');

        styles.innerHTML = `
          .kp-widget-root,
          .kp-modal-root {
              --kp-font-family: ano_regular,Helvetica,Arial,sans-serif !important;
          }
          .kp-widget-root {
              padding: 12px 0px;
          }
          .kp-widget-root b,
          .kp-modal-root b {
              --kp-font-family: ano-bold_regular,Helvetica,Arial,sans-serif !important;
          }
          .kp-widget-root .kueski-advice,
          .kp-widget-root p {
              font-size: 16px;
          }
          .kp-widget-root p {
            width: 100%;
            display: flex;
            gap: 4px;
            flex-wrap: wrap;
            align-items: center;
              justify-content: center;
            }
          `;
        shadow = document.querySelector('kueskipay-widget').shadowRoot;
        shadow.appendChild(styles);
      });
    }
  }, 300);
})();
